import api from './api';

export const ticketsService = {
  // Pobierz wszystkie zgłoszenia
  getTickets: async () => {
    const response = await api.get('/tickets');
    return response.data;
  },

  // Pobierz szczegóły zgłoszenia
  getTicket: async (id) => {
    const response = await api.get(`/tickets/${id}`);
    return response.data;
  },

  // Utwórz nowe zgłoszenie
  createTicket: async (ticketData) => {
    const formData = new FormData();
    
    formData.append('subject', ticketData.subject);
    formData.append('description', ticketData.description);
    formData.append('priority', ticketData.priority || 'sredni');

    // Dodaj screenshoty
    if (ticketData.screenshots && ticketData.screenshots.length > 0) {
      ticketData.screenshots.forEach(file => {
        formData.append('screenshots', file);
      });
    }

    const response = await api.post('/tickets', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Aktualizuj zgłoszenie
  updateTicket: async (id, ticketData) => {
    // Sprawdź czy są pliki do przesłania
    const hasFiles = ticketData.screenshots && ticketData.screenshots.length > 0;
    
    if (hasFiles) {
      // Jeśli są pliki, użyj FormData
      const formData = new FormData();
      
      if (ticketData.subject !== undefined) formData.append('subject', ticketData.subject);
      if (ticketData.description !== undefined) formData.append('description', ticketData.description);
      if (ticketData.priority !== undefined) formData.append('priority', ticketData.priority);
      if (ticketData.status !== undefined) formData.append('status', ticketData.status);
      if (ticketData.assignedTo !== undefined) {
        formData.append('assignedTo', ticketData.assignedTo || '');
      }
      
      // Dodaj screenshoty
      ticketData.screenshots.forEach(file => {
        formData.append('screenshots', file);
      });

      const response = await api.put(`/tickets/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } else {
      // Jeśli nie ma plików, wyślij jako JSON
      const jsonData = {};
      
      if (ticketData.subject !== undefined) jsonData.subject = ticketData.subject;
      if (ticketData.description !== undefined) jsonData.description = ticketData.description;
      if (ticketData.priority !== undefined) jsonData.priority = ticketData.priority;
      if (ticketData.status !== undefined) jsonData.status = ticketData.status;
      if (ticketData.assignedTo !== undefined) {
        jsonData.assignedTo = ticketData.assignedTo || null;
      }

      const response = await api.put(`/tickets/${id}`, jsonData);
      return response.data;
    }
  },

  // Dodaj komentarz do zgłoszenia
  addComment: async (id, text, screenshots = []) => {
    const formData = new FormData();
    formData.append('text', text);
    
    // Dodaj screenshoty
    if (screenshots && screenshots.length > 0) {
      screenshots.forEach(file => {
        formData.append('screenshots', file);
      });
    }

    const response = await api.post(`/tickets/${id}/comments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Dodaj screenshoty do istniejącego zgłoszenia
  addScreenshots: async (id, screenshots) => {
    const formData = new FormData();
    
    if (screenshots && screenshots.length > 0) {
      screenshots.forEach(file => {
        formData.append('screenshots', file);
      });
    }

    const response = await api.post(`/tickets/${id}/screenshots`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Usuń zgłoszenie
  deleteTicket: async (id) => {
    const response = await api.delete(`/tickets/${id}`);
    return response.data;
  }
};
